import React from "react";
import { TrustPill, type TrustLabel } from "../TrustPill";

interface ExecutiveKpiCardProps {
  label: string;
  value: string | number;
  trustLabel?: TrustLabel;
  source?: string;
  tone?: "neutral" | "good" | "warn" | "bad";
  hint?: string;
}

const TONE: Record<string, string> = {
  neutral: "bg-white border-ink-100",
  good: "bg-emerald-50 border-emerald-200",
  warn: "bg-amber-50 border-amber-200",
  bad: "bg-rose-50 border-rose-200",
};

export function ExecutiveKpiCard(props: ExecutiveKpiCardProps): React.ReactElement {
  return (
    <div className={`rounded-xl border p-4 ${TONE[props.tone ?? "neutral"]}`}>
      <div className="flex items-center justify-between gap-2 mb-1">
        <span className="text-xs uppercase tracking-wider text-ink-500">{props.label}</span>
        <TrustPill label={props.trustLabel} />
      </div>
      <div className="text-3xl font-display font-bold text-ink-900">{props.value}</div>
      {props.source && (
        <div className="text-[11px] text-ink-500 mt-1 font-mono">{props.source}</div>
      )}
      {props.hint && <div className="text-xs text-ink-600 mt-1">{props.hint}</div>}
    </div>
  );
}
